(() => {
  if (document.documentElement.lang.split('-')[0] !== 'nl') return;
  const config = document.getElementById('mw-review-language');
  if (!config) return;
  const labels = JSON.parse(config.textContent);
  const decimal = value => value.replace(/(\d)\.(\d)/g, '$1,$2');
  const format = (template, values) => template.replace(/\{(\w+)\}/g, (match, key) => values[key] ?? match);

  function translateVisible(value) {
    const trimmed = value.trim();
    if (!trimmed) return value;
    if (labels.visible?.[trimmed]) return value.replace(trimmed, labels.visible[trimmed]);
    let match = trimmed.match(/^Based on (\d+) reviews$/i);
    if (match) return value.replace(trimmed, format(labels.basedOn, { count: match[1] }));
    match = trimmed.match(/^Based on 1 review$/i);
    if (match) return value.replace(trimmed, format(labels.basedOnOne, { count: '1' }));
    return value;
  }

  function translateLabel(value) {
    if (labels.fixed[value]) return labels.fixed[value];
    let match = value.match(/^Page (\d+)$/);
    if (match) return format(labels.page, { number: match[1] });
    match = value.match(/^Link to user picture (\d+)$/);
    if (match) return format(labels.userPictureLink, { number: Number(match[1]) + 1 });
    match = value.match(/^Average rating is ([\d.]+)(?: stars)?$/i);
    if (match) return format(labels.average, { rating: decimal(match[1]) });
    match = value.match(/^(.*?) reviews with (\d) star rating$/i);
    if (match) return format(labels.histogram, { prefix: match[1], stars: match[2] }).replace('1 sterren', '1 ster');
    match = value.match(/^(.*?) review photo( \d+)?$/i);
    if (match) return format(labels.photo, { name: match[1], number: match[2] || '' });
    match = value.match(/^([\d.]+) star review$/i);
    if (match) return format(labels.rating, { rating: decimal(match[1]) });
    match = value.match(/^([\d.]+) stars?$/i);
    if (match) return format(labels.stars, { rating: decimal(match[1]) }).replace(/^1 sterren$/, '1 ster');
    const medals = [
      [/^Diamond Authentic Shop\. ([\d.]+)% of published reviews are verified reviews$/, 'authentic'],
      [/^Diamond Transparent Shop\. Published ([\d.]+)% of verified reviews received in total$/, 'transparent'],
      [/^Silver Verified Reviews Shop\. Obtained at least (\d+) reviews submitted by genuine customers with proof of purchase history$/, 'verified'],
      [/^Bronze Monthly Record Shop\. Achieved an all-time record of (\d+) published verified reviews within one calendar month\.$/, 'record']
    ];
    for (const [pattern, key] of medals) {
      match = value.match(pattern);
      if (match) return format(labels[key], { number: decimal(match[1]) });
    }
    return value;
  }

  const roots = new WeakSet();
  let queued = false;
  function translate() {
    queued = false;
    document.querySelectorAll('.jdgm-widget').forEach(root => {
      if (!roots.has(root)) {
        roots.add(root);
        observer.observe(root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['aria-label', 'alt', 'title'] });
      }
      root.querySelectorAll('.jdgm-sort-dropdown-label').forEach(element => {
        if (element.textContent !== labels.sort) element.textContent = labels.sort;
      });
      root.querySelectorAll('.jdgm-sort-dropdown').forEach(element => {
        if (element.getAttribute('aria-label') !== labels.sort) element.setAttribute('aria-label', labels.sort);
      });
      root.querySelectorAll('.jdgm-rev-widg__summary-average, .jdgm-all-reviews__summary-average').forEach(element => {
        const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
        while (walker.nextNode()) {
          const node = walker.currentNode;
          const next = decimal(node.nodeValue);
          if (next !== node.nodeValue) node.nodeValue = next;
        }
      });
      const visibleWalker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      while (visibleWalker.nextNode()) {
        const node = visibleWalker.currentNode;
        const next = translateVisible(node.nodeValue || '');
        if (next !== node.nodeValue) node.nodeValue = next;
      }
      [root, ...root.querySelectorAll('[aria-label], [alt], [title]')].forEach(element => {
        for (const attribute of ['aria-label', 'alt', 'title']) {
          const before = element.getAttribute(attribute);
          if (!before) continue;
          const after = translateLabel(before);
          if (after !== before) element.setAttribute(attribute, after);
        }
      });
    });
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(translate);
  }
  const observer = new MutationObserver(schedule);
  const discovery = new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('.jdgm-widget') || node.querySelector('.jdgm-widget'))))) schedule();
  });
  discovery.observe(document.body, { childList: true, subtree: true });
  translate();
})();
